import React from "react";
import { Link } from "react-router-dom";
import style from "./Footer.module.css";
import { useI18n } from "../../i18n/I18n";

const Footer: React.FC = () => {
  const { t } = useI18n();
  return <footer className={style.footer}>
    <div className={`container ${style.grid}`}>
      <div><Link className={style.logo} to="/"><span>muz</span>shop</Link><p>{t("footerTagline")}</p></div>
      <div><b>{t("navigation")}</b><Link to="/instruments">{t("catalog")}</Link><Link to="/order">{t("customOrder")}</Link></div>
      <div><b>{t("contact")}</b><a href="tel:+380999999999">+380 99 999 99 99</a><a href="mailto:muzshop@example.com">muzshop@example.com</a></div>
    </div>
    <div className={`container ${style.bottom}`}><span>© 2026 muzshop</span><span>{t("delivery")}</span></div>
  </footer>
};
export default Footer;
